import { useBreakpointValue } from "@chakra-ui/react";

export const useIsMobile = () => {
  const viewType = useBreakpointValue({ base: "mobile", md: "large" });
  return viewType === "mobile";
};
